/**
 * Normalizes socket/API notification payloads (EyeconXNotificationPayloadDTO).
 */
export function formatPhoneNumber(value) {
    if (value == null || value === '') {
        return null;
    }
    const digits = String(value).replace(/\D/g, '');
    if (digits.length === 10) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    if (digits.length === 11 && digits.startsWith('1')) {
        return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    }
    return String(value);
}

export function formatNotificationTypeLabel(type) {
    if (!type) {
        return 'Notification';
    }
    return String(type)
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function getNotificationTypeBadgeClass(type) {
    const normalized = String(type || '').toUpperCase();
    if (normalized.includes('SMS')) {
        return 'bg-success bg-opacity-10 text-success';
    }
    return 'bg-primary bg-opacity-10 text-primary';
}

export function parseIncomingNotification(data) {
    const customer = data.customer ?? data.customerNumber ?? null;
    const business = data.business ?? null;
    const clinicId = data.clinicId != null ? String(data.clinicId) : null;
    const notificationType = data.notificationType ?? data.type ?? null;
    const messageId = data.messageId != null ? data.messageId : null;

    return {
        id: messageId != null
            ? `msg-${messageId}`
            : `${Date.now()}-${customer || clinicId || 'notification'}`,
        message: data.message ?? '',
        clinicId,
        notificationType,
        customer: customer != null ? String(customer) : null,
        business: business != null ? String(business) : null,
        messageId,
        status: data.status ?? null,
        timestamp: new Date().toISOString(),
    };
}
